import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Question from '../Question/Question';
import s from './QuestionWrapper.scss';

const QuestionWrapper = props => {
  const {
    handleSnackBar,
    isCategory = false,
    onChangeOptions,
    activeQuestion,
    totalQuestions,
    onHandleSubmit,
    onHandleChangeQuestion,
    requiredToast,
    hideRequiredToast,
    answers,
  } = props;

  const { title, subtitle, required, msid, descriptor } = props.question || {};

  const [active, setActive] = useState(!required);

  useEffect(
    () => {
      if (!required) {
        return setActive(true);
      } else if (
        Array.isArray(answers[msid]) &&
        answers[msid].length >= (descriptor?.maxlimitforselection || 0)
      ) {
        return setActive(true);
      } else if (!Array.isArray(answers[msid]) && answers[msid]) {
        return setActive(true);
      }
      return setActive(false);
    },
    [props.question],
  );

  useEffect(
    () => {
      setTimeout(() => {
        hideRequiredToast();
      }, 3000);
    },
    [requiredToast],
  );

  const toggleButton = (e, selected) => {
    onChangeOptions(e, selected);
    if (
      e.target.type === 'checkbox' &&
      selected.length >= (descriptor?.maxlimitforselection || 0) &&
      !!required
    ) {
      setActive(true);
    } else if (
      e.target.type === 'checkbox' &&
      selected.length >= (descriptor?.maxlimitforselection || 0) &&
      !required
    ) {
      setActive(true);
    } else if (e.target.type !== 'checkbox' && selected) {
      setActive(true);
    } else {
      setActive(false);
    }

    if (isCategory && props.isWapView) {
      window.scrollTo({
        top: 250,
        behavior: 'smooth',
      });
    }
  };

  return (
    <>
      {!isCategory && (
        <div className={s.questionCount}>
          Question {activeQuestion + 1} / {totalQuestions}
        </div>
      )}
      <div className={s.sqWrap}>
        <div className={s.questionTitle}>
          {title} {!!required && !isCategory && <sup>*</sup>}
        </div>
        <div className={s.questionSubTitle}>{subtitle}</div>
        <ul className={s.sqListWrap}>
          <Question
            question={props.question}
            handleSnackBar={handleSnackBar}
            isCategory={isCategory}
            isWapView={props.isWapView}
            onChangeOptions={toggleButton}
            answers={answers}
          />
        </ul>
        <div className={s.buttonWrap}>
          {!!activeQuestion && (
            <button
              className={`${s.button} ${s.btnBordered}`}
              type="button"
              onClick={() => onHandleChangeQuestion(active, -1)}
            >
              PREVIOUS {!props.isWapView && 'QUESTION'}
            </button>
          )}
          {activeQuestion === totalQuestions - 1 ? (
            <button
              className={`${s.button} ${s.show} ${!active ? s.disabled : null}`}
              type="button"
              onClick={() => onHandleSubmit(active)}
            >
              {isCategory ? 'PROCEED TO SURVEY' : 'SUBMIT'}
            </button>
          ) : (
            <button
              className={`${s.button} ${s.show} ${!active ? s.disabled : null}`}
              type="button"
              onClick={() => onHandleChangeQuestion(active)}
            >
              NEXT {!props.isWapView && 'QUESTION'}
            </button>
          )}
        </div>
        <div className={`${s.errorToast} ${requiredToast ? s.show : null}`}>
          {isCategory
            ? `Please select a category to proceed further`
            : `Please answer this question to proceed further`}
        </div>
      </div>
    </>
  );
};

QuestionWrapper.propTypes = {
  handleSnackBar: PropTypes.func.isRequired,
  isCategory: PropTypes.bool,
  onChangeOptions: PropTypes.func.isRequired,
  activeQuestion: PropTypes.number,
  totalQuestions: PropTypes.number,
  onHandleSubmit: PropTypes.func.isRequired,
  onHandleChangeQuestion: PropTypes.func.isRequired,
  requiredToast: PropTypes.bool,
  hideRequiredToast: PropTypes.func.isRequired,
  answers: PropTypes.array,
  isWapView: PropTypes.bool,
  question: PropTypes.object,
};

QuestionWrapper.defaultProps = {
  isCategory: false,
  activeQuestion: 0,
  totalQuestions: 0,
  requiredToast: false,
  isWapView: false,
  answers: [],
  question: {},
};

export default React.memo(QuestionWrapper);
